<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :max-width="$vuetify.breakpoint.xsOnly ? '' : '600'"
    :hide-overlay="$vuetify.breakpoint.xsOnly"
    :transition="$vuetify.breakpoint.xsOnly ? 'dialog-bottom-transition' : ''"
    :persistent="saving"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{ $t('user_management.change_email') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark :disabled="saving" @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="mt-5">{{ $t('user_management.change_email_info') }}</p>
        <v-text-field :value="user ? user.email : ''" :label="$t('user_management.current_email')" disabled />
        <v-form ref="form" @submit.prevent="save">
          <v-text-field
            v-model="email"
            :rules="[$rules.required, $rules.email, $rules.spacesNotAllowed]"
            :label="$t('user_management.new_email')"
            :disabled="saving"
            validate-on-blur
            autocomplete="off"
            autofocus
          />
        </v-form>
      </v-card-text>
      <v-divider v-if="$vuetify.breakpoint.smAndUp"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="saving" @click="dialog = false">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">{{ $t('user_management.change_email') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import tenantApi from '@/api/tenant';

export default {
  name: 'ChangeEmailDialog',
  data() {
    return {
      dialog: false,
      saving: false,
      user: null,
      email: '',
    };
  },
  methods: {
    open(user) {
      this.user = user;
      this.email = '';
      this.dialog = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
    async save() {
      // Puhelimen näppäimistö jättää automaattitäydennyksen perään välilyönnin.
      this.email = this.email.trim().toLowerCase();
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saving = true;
      try {
        const response = await tenantApi.changeUserEmail(this.user.subject, this.email);
        this.$showSuccessNotification(
          this.$t(response.activationEmailSent ? 'user_management.email_changed_invite_sent' : 'user_management.email_changed')
        );
        this.$emit('email-changed', response.email);
        this.dialog = false;
      } catch (error) {
        const status = error.response?.data?.status;
        if (status === 'email_in_use') {
          this.$showErrorNotification(this.$t('user_management.errors.email_exists'));
        } else if (status === 'user_in_other_tenants') {
          this.$showErrorNotification(this.$t('user_management.user_in_other_tenants'));
        } else {
          this.$handleApiError(error, this.$t('user_management.email_change_failed'));
        }
      }
      this.saving = false;
    },
  },
};
</script>
